import React from 'react';
import TableItem from '../Table';
import BarChartItem from '../BarChartItem';

interface BalanceSheetTabProps {
  companyData: any;
}

export default function BalanceSheetTab({ companyData }: BalanceSheetTabProps) {
  if (!companyData) return null;

  return (
    <div className="space-y-8 min-w-0">
      {/* Balance Sheet Table */}
      {companyData.balance_sheet && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Balance Sheet</h3>
          <TableItem table={companyData.balance_sheet} head_bold={true} bold_column_indexes={[0]} />
        </section>
      )}

      {/* Assets Chart */}
      {companyData.balance_sheet_assets_chart_data && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Assets</h3>
          <BarChartItem
            name="Balance Sheet: Assets"
            x_axis={companyData.balance_sheet_assets_chart_data.x_axis}
            data={companyData.balance_sheet_assets_chart_data.data}
          />
        </section>
      )}

      {/* Liabilities Chart */}
      {companyData.balance_sheet_liabilities_chart_data && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Liabilities</h3>
          <BarChartItem
            name="Balance Sheet: Liabilities"
            x_axis={companyData.balance_sheet_liabilities_chart_data.x_axis}
            data={companyData.balance_sheet_liabilities_chart_data.data}
          />
        </section>
      )}
    </div>
  );
}
